// 合同起草列表页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="合同在线起草"></route-name>
    <!-- content 内容 -->
    <div class="content">
      <!-- 搜索栏 -->
      <div class="search">
        <div>
          <el-button type="primary" plain size="small" @click="draftUp"
            ><i class="el-icon-upload"></i>&nbsp;&nbsp;&nbsp;上传文件</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="
              () => {
                $router.push({ path: '/smartDoc/docDraft/draft' });
              }
            "
            ><i class="el-icon-document-add"></i
            >&nbsp;&nbsp;&nbsp;选择模板</el-button
          >
          <el-button size="small" @click="delDoc"
            ><i class="el-icon-delete"></i>&nbsp;&nbsp;&nbsp;删除文件</el-button
          >
        </div>
        <div>
          <el-input
            placeholder="请输入文件名"
            v-model="fileName"
            size="small"
            clearable
          >
          </el-input>
          <el-button
            size="small"
            @click="searchData(1)"
            style="margin-left: 10px"
            >查询</el-button
          >
          <el-button size="small" @click="rest">重置</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        style="min-height: 64vh"
        :data="drafData"
        border
        v-loading="TableLoading"
        @selection-change="
          (rows) => {
            this.selected = rows;
          }
        "
      >
        <el-table-column type="selection" width="45" />
        <el-table-column
          prop="docIndex"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column prop="contractName" label="合同名称"></el-table-column>
        <el-table-column
          prop="createTime"
          label="合同起草时间"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="最后修改时间"
        ></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span :style="{ color: drafStatus[scope.row.draftStatus].color }">{{
              drafStatus[scope.row.draftStatus].status
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              class="action pointer"
              v-if="scope.row.draftStatus == 1"
              @click="toComplete(scope.row)"
              >立即加入</span
            >
            <span
              class="action pointer"
              v-if="
                scope.row.fggUserFlag == 'super' && scope.row.draftStatus == 1
              "
              @click="aboutAdd(scope.row)"
              >添加相关方</span
            >
            <span
              class="action pointer"
              v-if="
                scope.row.fggUserFlag == 'super' && scope.row.draftStatus == 1
              "
              @click="toComplete(scope.row)"
              >完成</span
            >
            <span
              class="action pointer"
              v-if="scope.row.draftStatus == 2"
              @click="toComplete(scope.row)"
              >查看详情</span
            >
            <span
              class="action pointer"
              v-if="
                scope.row.draftStatus == 2 && scope.row.fggUserFlag == 'super'
              "
              @click="draftAgain(scope.row)"
              >再次起草</span
            >
            <span
              class="action pointer"
              v-if="
                scope.row.draftStatus == 2 && scope.row.fggUserFlag == 'super'
              "
              @click="contractUp(scope.row)"
              >合同发起</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row>
        <div class="page-sty page-flex-end">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageModel.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageModel.pageSize"
            layout="sizes, prev, pager, next, total"
            :total="pageModel.total"
          />
          <el-go
            :page-size="pageModel.pageSize"
            :total="pageModel.total"
            @current-change="handleCurrentChange"
          ></el-go>
        </div>
      </el-row>
    </div>
    <!-- 添加相关方窗口 -->
    <el-dialog title="添加相关方" :visible.sync="ADDVisible" width="40%">
      <div class="propos-box">
        <el-form v-for="(item, i) in propos" :key="i" :model="item" inline>
          <el-form-item
            prop="phoneOrEmail"
            :label="`合同拟定方${i + 1}: `"
            :rules="propRule"
          >
            <el-input
              clearable
              size="small"
              v-model="item.phoneOrEmail"
              placeholder="请输入邮箱/手机号"
              style="padding-left: 15px"
              @input="partAdd(i, $event)"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="名称: "
            :rules="[
              { required: true, message: '请输入名称', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="item.userName"
              size="small"
              placeholder="请输入名称"
              style="padding-left: 15px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="propos-action">
              <img
                src="/images/AISmart/icon/del.png"
                alt=""
                style="margin-right: 20px"
                v-show="propos.length - 1 > 0"
                @click="delItem(item)"
              />
              <img
                src="/images/AISmart/icon/puls.png"
                alt=""
                v-show="propos.length - 1 == i"
                @click="addItem"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ADDCancel">取 消</el-button>
        <el-button type="primary" @click="ADDSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 组件
import ElGo from "@/components/go/Go.vue";
import RouteName from "@/components/route-name";
// 接口
import {
  ApiMethods,
  postFindByEmailOrMphon
} from "../../../assets/js/http-serve/http-methods";
import { changeLgAccount } from "../../../assets/js/http-serve/corp/common";
// tool
import GlobalConfig from "@/assets/js/config/global";
import {
  mobileOrEmail,
  happy
} from "@/assets/js/lib/valid-methods";
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      // 添加相关方
      draftId: "",
      ADDVisible: false,
      propos: [
        {
          phoneOrEmail: "",
          userName: ""
        }
      ],
      propRule:[
        {
          required: true,
          message: '请输入邮箱/手机号',
          trigger: ['blur', 'change'],
        },
        { validator: mobileOrEmail, trigger: ['blur', 'change'] }
      ],
      // 添加相关方 end
      TableLoading: false,
      smartAPI: ApiMethods.AIDocSmart,
      fileName: "",
      drafData: [],
      pageModel: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      selected: [],
      drafStatus: {
        0: { status: "正在起草", color: "#189aff" },
        1: { status: "进行中", color: "#fcb270" },
        2: { status: "起草完成", color: "#67c23a" },
        3: { status: "起草失败", color: "#f56c6c" }
      }
    };
  },
  // data end
  methods: {
    // 重置
    rest () {
      this.fileName = "";
      this.searchData(1);
    },
    // 搜索
    searchData (pageNo) {
      this.TableLoading = true;
      const { page, pageSize } = this.pageModel;
      const params = {
        fileName: this.fileName,
        page,
        pageSize
      };
      if (pageNo) params.page = 1;
      this.smartAPI.draftList(params).then(res => {
        if (res.success) {
          const { data } = res;
          data.data.forEach((elem, i) => {
            elem.docIndex = (data.pageNum - 1) * data.pageSize + i + 1;
          });
          this.drafData = data.data;
          this.pageModel.total = data.total;
        } else {
          this.$message.error(res.description);
        }
        this.TableLoading = false;
      });
    },
    // 上传文件（起草）
    async draftUp () {
      this.$router.push("/smartContract/proposed");
    },
    // 删除文件
    delDoc () {
      if (this.selected.length === 0)
        return this.$message.error("请选择要操作的数据");
      // 需要取出selected数组中的id
      let Ids = [];
      this.selected.forEach(item => {
        Ids.push(item.contractDraftId);
      });
      this.smartAPI.draft_Del({ draftIds: Ids.toString() }).then(res => {
        if (res.success) {
          this.$message.success(res.description);
          this.selected = [];
          this.searchData();
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 添加相关方窗口
    aboutAdd (row) {
      this.draftId = row.contractDraftId;
      this.ADDVisible = !this.ADDVisible;
    },
    ADDCancel () {
      this.draftId = "";
      this.propos = [
        {
          phoneOrEmail: "",
          userName: ""
        }
      ];
      this.ADDVisible = false;
    },
    // 添加相关方
    ADDSubmit () {
      let phoneList = [];
      for (let i = 0; i < this.propos.length; i++) {
        const prop = this.propos[i];
        if (!prop.phoneOrEmail)
          return this.$message.error("请完成相关拟定方设置");
        phoneList.push(prop.phoneOrEmail);
      }
      let data = {
        draftId: this.draftId,
        emailOrMobileList: phoneList
      };
      this.smartAPI.participantAdd(data).then(res => {
        if (res.success) {
          this.ADDCancel();
          this.searchData();
          this.$message.success(res.description);
        } else {
          this.$message.error(res.description);
        }
      });
    },

    // 添加相关方表单
    addItem () {
      this.propos.push({
        phoneOrEmail: "",
        userName: ""
      });
    },
    // 查询拟定方是否存在及公司信息
    partAdd (index, val) {
      const phoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
        EmailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (phoneReg.test(val) || EmailReg.test(val)) {
        postFindByEmailOrMphon({targetId:val}).then(res => {
          if (res.success) {
            this.propos[index].userName = res.data[0].name;
          } else {
            this.$message.error(res.description);
          }
        });
      }
    },
    // 删除相关方
    delItem (item) {
      var index = this.propos.indexOf(item);
      if (index !== -1) {
        this.propos.splice(index, 1);
      }
    },
    // 再次起草
    draftAgain (row) {
      this.$router.push({
        name: "smartContract-proposed",
        params: {
          contractDraftId: row.contractDraftId,
          name: row.contractName
        }
      });
    },
    // 合同发起
    contractUp (row) {
      if (this.allAuthUser.accountInfoVO.userStemFrom == -16) {
        return this.$message.warning("不支持钉钉用户发起合同");
      }
      this.changeLoginAccount(() => {
        let routeUrl = this.$router.resolve({
          path: "/initiation/toCreate"
        });
        const url = `${routeUrl.href}?contractDraftId=${row.contractDraftId}&contractName=${row.contractName}`;
        window.open(url, "_blank");
      });
    },
    // 切换登录用户
    changeLoginAccount (callback) {
      changeLgAccount().finally(() => {
        callback && callback();
      });
    },
    // 下载报告
    toComplete (row) {
      this.turnFGG(row);
    },

    // 跳转发狗狗页面
    turnFGG (row) {
      this.$router.push({
        path: "/iframbox",
        query: { key: encodeURIComponent(JSON.stringify(row.contractDraftId)) }
      });
    },
    // 每页条数改变
    handleSizeChange (val) {
      this.pageModel.page = 1;
      this.pageModel.pageSize = val;
      this.searchData();
    },
    // 页数改变
    handleCurrentChange (val) {
      this.pageModel.page = val;
      this.searchData();
    }
  },
  // methods end
  components: { RouteName, ElGo },
  created () {
    this.searchData();
  },
  computed: {
    ...mapGetters(["allAuthUser"])
  }
};
</script>

<style scoped lang="less">
.page-sty {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    /*height: calc(85vh - 36px);*/
    padding: 16px;
    overflow: auto;
    .search {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      > div {
        width: 300px;
        display: flex;
        align-items: center;
      }
    }
  }
  .action {
    display: inline-block;
    cursor: pointer;
    margin: 0 5px;
    color: #290202;
  }
  .propos-box {
    width: 100%;
    height: 35vh;
    overflow: auto;
    .propos-action {
      > img {
        width: 34px;
        height: 34px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docDraft/draftList.vue